import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-surfaceDark text-textLight border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        <div>
          <h3 className="text-gold font-serif text-2xl mb-6 tracking-wide">LuxeJewels</h3>
          <p className="text-textMuted text-sm font-light leading-relaxed">
            The epitome of luxury. We deliver meticulously crafted, timeless pieces directly to your doorstep with our fully insured, white-glove service.
          </p>
        </div>

        <div>
          <h3 className="text-white font-serif text-lg mb-6 tracking-widest uppercase text-sm">Discover</h3>
          <ul className="space-y-4">
            <li><Link to="/about" className="text-textMuted hover:text-gold transition-colors duration-300 text-sm font-light">Our Legacy</Link></li>
            <li><Link to="/contact" className="text-textMuted hover:text-gold transition-colors duration-300 text-sm font-light">Contact Concierge</Link></li>
            <li><Link to="/shipping" className="text-textMuted hover:text-gold transition-colors duration-300 text-sm font-light">Shipping Policy</Link></li>
            <li><Link to="/returns" className="text-textMuted hover:text-gold transition-colors duration-300 text-sm font-light">Returns & Exchanges</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-serif text-lg mb-6 tracking-widest uppercase text-sm">Client Care</h3>
          <ul className="space-y-4 text-sm font-light">
            <li><a href="tel:+1234567890" className="text-textMuted hover:text-gold transition-colors duration-300">+1 (234) 567-890</a></li>
            <li><a href="mailto:concierge@luxejewels.com" className="text-textMuted hover:text-gold transition-colors duration-300">concierge@luxejewels.com</a></li>
            <li className="text-textMuted">24/7 Global Support</li>
            <li className="text-textMuted">Private Appointments</li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-serif text-lg mb-6 tracking-widest uppercase text-sm">Follow Us</h3>
          <div className="flex gap-6 text-xl">
            <a href="#facebook" className="text-textMuted hover:text-gold transition-colors duration-300 transform hover:-translate-y-1"><FaFacebook /></a>
            <a href="#twitter" className="text-textMuted hover:text-gold transition-colors duration-300 transform hover:-translate-y-1"><FaTwitter /></a>
            <a href="#instagram" className="text-textMuted hover:text-gold transition-colors duration-300 transform hover:-translate-y-1"><FaInstagram /></a>
            <a href="#linkedin" className="text-textMuted hover:text-gold transition-colors duration-300 transform hover:-translate-y-1"><FaLinkedin /></a>
          </div>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 border-t border-white/5 pt-8 text-center flex flex-col items-center">
        <div className="w-8 h-[1px] bg-gold mb-6"></div>
        <p className="text-textMuted text-xs tracking-widest uppercase font-light">&copy; {new Date().getFullYear()} LuxeJewels. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
